module.exports = __webpack_public_path__ + "static/media/mobile_deposit_back.031c3ce5.png";